import script from "./ForceGraph.vue?vue&type=script&setup=true&lang=js"
export * from "./ForceGraph.vue?vue&type=script&setup=true&lang=js"

import "./ForceGraph.vue?vue&type=style&index=0&id=7931bfc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7931bfc4"]])

export default __exports__